<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import './assets/fonts/style.css';
@import './assets/weather-icons/css/weather-icons.css';
@import '../node_modules/slick-carousel/slick/slick.css';
@import '../node_modules/slick-carousel/slick/slick-theme.css';

@import './styles/topcv.scss';
@import '~vue-awesome-notifications/dist/styles/style.scss';
#awn-toast-container{
  top: 24px;
}
</style>




// WEBPACK FOOTER //
// src/App.vue